import { Borders, Row, Workbook, Worksheet } from "exceljs"
import moment from "moment"
import { StatusEnum } from "../.."
import { DataList } from "../../types"

type ExportExcel = {
  data: DataList[]
  companyName?: string
}

export const exportExcel = async ({ data }: ExportExcel) => {
  const workbook = new Workbook()
  const worksheet = workbook.addWorksheet("Sheet 1")
  const columns = ["NO", "DATE", "FILENAME", "DESCRIPTION", "STATUS"]
  worksheet.views = [{ showGridLines: false }]

  worksheet.mergeCells(2, 1, 1, columns.length)

  // Title
  makeTitle(worksheet)

  // Header
  const headers = worksheet.addRow(columns)
  headers.font = { bold: true }
  headers.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF8C308" }
    }
    cell.border = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } }
    }
  })

  makeRows(data, worksheet)

  // create xlsx
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "product-item.xlsx"
    a.click()
    URL.revokeObjectURL(url)
  })
}

function makeTitle(worksheet: Worksheet) {
  const titleCell = worksheet.getCell(1, 2)
  titleCell.value = "PRODUCT ITEM"
  titleCell.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  }
  titleCell.font = { bold: true, size: 15 }

  worksheet.getColumn(2).width = 20
}

function makeRows(data: ExportExcel["data"], worksheet: Worksheet) {
  let itemRow: Row

  const cellBorder: Partial<Borders> = {
    top: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } },
    bottom: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } }
  }

  data.forEach((item, index) => {
    itemRow = worksheet.addRow([
      index + 1,
      moment(item.transaction_date).format("DD/MM/YYYY"),
      item.file_name,
      item.file_description,
      Number(item.status) === StatusEnum.Review ? "Review" : "Submit"
    ])

    itemRow.eachCell((cell) => {
      cell.border = cellBorder
    })
  })
}
